module.exports = "/fonts/vendor/desiigner-svg/svg/fontawesome/light/car-bus.svg?c271fdf261ae54a21e725b3a9ce5344c";